/**
Copyright (c) 2022–2026 Podstack.ai
All rights reserved.
Proprietary and Confidential.
Unauthorized copying of this file, via any medium, is strictly prohibited.
This file is part of the Podstack Platform.
*/

import React from 'react';
import { XMarkIcon, ArrowUpTrayIcon } from '@heroicons/react/24/outline';

interface UploadModalProps {
    isOpen: boolean;
    onClose: () => void;
    onUpload: (files: FileList | null) => void;
}

const UploadModal: React.FC<UploadModalProps> = ({ isOpen, onClose, onUpload }) => {
    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
            <div className="bg-gray-900 rounded-2xl shadow-xl w-full max-w-md mx-4 border border-gray-800">
                <div className="flex items-center justify-between p-6 border-b border-gray-700">
                    <h3 className="text-lg font-semibold text-white">Upload Files</h3>
                    <button
                        onClick={onClose}
                        className="p-2 text-gray-400 hover:text-gray-300 rounded-lg"
                    >
                        <XMarkIcon className="w-5 h-5" />
                    </button>
                </div>
                <div className="p-6">
                    <div className="border-2 border-dashed border-gray-600 rounded-xl p-8 text-center">
                        <ArrowUpTrayIcon className="w-12 h-12 text-gray-400 mx-auto mb-4" />
                        <p className="text-gray-400 mb-2">Drag and drop files here, or</p>
                        <label className="btn-primary inline-flex cursor-pointer">
                            Browse Files
                            <input
                                type="file"
                                multiple
                                onChange={(e) => onUpload(e.target.files)}
                                className="hidden"
                            />
                        </label>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UploadModal;
